import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { BoxBone } from '../../atoms/BoxBone/BoxBone';
import { TextBone } from '../../atoms/TextBone/TextBone';

export interface HeaderBoneProps {
    /** Afficher avec icône */
    withIcon?: boolean;
    /** Largeur de l'icône */
    iconWidth?: string;
    /** Largeur du contenu */
    contentWidth?: string;
    /** Hauteur de l'en-tête */
    headerHeight?: string;
    /** Nombre d'éléments sous l'en-tête */
    subItemCount?: number;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const HeaderBone: React.FunctionComponent<HeaderBoneProps> = function ({
    withIcon = true,
    iconWidth = '8%',
    contentWidth = '92%',
    headerHeight = '112px',
    subItemCount = 3,
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: 2,
                width: '100%',
                padding: '16px',
                ...sx,
            }}
        >
            {withIcon ? (
                <Box sx={{ width: iconWidth }}>
                    <BoxBone sx={{ width: '100%', height: headerHeight }} />
                </Box>
            ) : null}
            <Box sx={{ width: contentWidth }}>
                <BoxBone sx={{ width: '100%', height: headerHeight, marginBottom: 1 }} />
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, width: '50%' }}>
                    {Array.from({ length: subItemCount }).map((_, index) => (
                        <TextBone
                            key={`header-sub-item-${subItemCount}-${index + 1}`}
                            sx={{ width: '33%', height: '24px' }}
                        />
                    ))}
                </Box>
            </Box>
        </Box>
    );
};
